export const NotFoundPage = () => (
  <main className="not-found-page-wrap">
    <section className="not-found-page">
      <h1 className="title">Sorry, this page isn't available.</h1>
      The link you followed may be broken, or the page may have been removed.
    </section>
  </main>
);
